import { FormattedMessage, useIntl } from 'react-intl';

import { Modal, Form, Button } from 'antd';
import TaskReportForm from '../TaskReportForm/index';
import { ModalProps } from '@/types/ModalProps';
import { ReportCallback } from '@/hooks/useReportGenerate';
import { useGenerateTaskReport } from '@/core/domain/reports/task/Report.hooks';
import { useDefaultFormErrorNotification, useReportGenerate } from '@/hooks';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import SpaceForButton from '@/components/_common/SpaceForButtons';

function TaskReportModal({ visible, handleVisible }: ModalProps) {
  const intl = useIntl();

  const [form] = Form.useForm();

  const mutation = useGenerateTaskReport();
  const { sendFormErrorNotification } = useDefaultFormErrorNotification();
  const { openFile, downloadFile } = useReportGenerate();
  const { fileLoading, setFileLoading, setFileUnloading, FILE_FORMAT } =
    useFileLoading();

  const handleGenerateReport = async (
    format: FileType,
    callback: ReportCallback,
  ) => {
    setFileLoading(format);
    try {
      const values = await form.getFieldsValue();
      const obj = { ...values, format: FILE_FORMAT[format] };
      const result = await mutation.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch (err) {
      sendFormErrorNotification(err);
    }
    setFileUnloading(format);
  };

  return (
    <Modal
      width={660}
      open={visible}
      onCancel={handleVisible}
      title={intl.formatMessage({ id: 'tasks.modal.report.title' })}
      footer={
        <SpaceForButton justifyContent="end">
          <Button
            loading={fileLoading.REPORT_VIEW}
            type="primary"
            key="viewReport"
            block
            onClick={() =>
              handleGenerateReport('REPORT_VIEW', (result) =>
                openFile({
                  result,
                  fileName: 'Serviços.pdf',
                  fileType: 'application/pdf',
                }),
              )
            }
          >
            <FormattedMessage id="tasks.modal.report.buttons.viewReport" />
          </Button>
          <Button
            loading={fileLoading.PDF}
            type="primary"
            key="pdf"
            block
            onClick={() =>
              handleGenerateReport('PDF', (result) =>
                downloadFile({
                  result,
                  fileName: 'Serviços.pdf',
                }),
              )
            }
          >
            <FormattedMessage id="tasks.modal.report.buttons.pdf" />
          </Button>
          <Button
            loading={fileLoading.CSV}
            type="primary"
            key="csv"
            block
            onClick={() =>
              handleGenerateReport('CSV', (result) =>
                downloadFile({
                  result,
                  fileName: 'Serviços.csv',
                }),
              )
            }
          >
            <FormattedMessage id="tasks.modal.report.buttons.csv" />
          </Button>
        </SpaceForButton>
      }
    >
      <TaskReportForm form={form} />
    </Modal>
  );
}

export default TaskReportModal;
